import type { ReactNode } from "react";

type Width = "narrow" | "default" | "wide";

function widthClass(width: Width): string {
  // Full-bleed everywhere: every tier fills the viewport width (page padding
  // only). The `width` prop is retained for callers but no longer caps width.
  switch (width) {
    case "narrow":
      return "max-w-none"; // forms, detail pages
    case "wide":
      return "max-w-none"; // dashboards (budget, renofond)
    default:
      return "max-w-none"; // list pages
  }
}

export function PageContainer({
  width = "default",
  children,
}: {
  width?: Width;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className={`mx-auto ${widthClass(width)} p-6`}>{children}</div>
  );
}
